import { FileType } from '@/shared/graphql/legacy/generated'

export const getFileType = (fileName: string, fileType: string): FileType => {
  const [type, subType] = fileType.split('/')
  const ignoreSubTypeList = ['svg+xml', 'vnd.adobe.photoshop']

  if (
    (type === 'audio' || type === 'video' || type === 'image') &&
    !ignoreSubTypeList.includes(subType)
  ) {
    const category = type.toUpperCase()

    return category as FileType
  }

  const filename = fileName

  if (!filename) throw new Error('Filename not provided.')

  let extension = filename.match(/.[0-9a-z]+$/i)?.[0]

  if (!extension) throw new Error('Extension not provided.')

  // Remove "."
  extension = extension.substring(1)

  const map = {
    TABLE: ['csv', 'numbers'],
    CODE: [
      'html',
      'css',
      'js',
      'ts',
      'vue',
      'jsx',
      'tsx',
      'py',
      'c',
      'cpp',
      'h',
      'swift',
      'java',
      'rs',
      'go',
      'graphql',
    ],
    PDF: ['pdf'],
    TEXT: ['txt', 'md', 'odt'],
    ZIP: ['zip'],
    VECTOR: ['svg'],
    THREE_D: [
      'stp',
      'max',
      'fbx',
      'obj',
      'x3d',
      'vrml',
      '3ds',
      '3mf',
      'stl',
      'dae',
    ],
    ADOBE_AFTER_EFFECTS: ['aep'],
    ADOBE_AUDITION: ['sesx'],
    ADOBE_ILLUSTRATOR: ['ai'],
    ADOBE_INDESIGN: ['indd'],
    ADOBE_PHOTOSHOP: ['psd'],
    ADOBE_PREMIER_PRO: ['prproj'],
    AUTODESK_AUTODAC: ['dwg'],
    AUTODESK_FUSION: ['f3d'],
    AUTODESK_MAYA: ['mb'],
    CINEMA_4D: ['c4d'],
    DAVINCI_RESOLVE: ['drp'],
    MS_POWER_POINT: ['ppt'],
    MS_ACCESS: ['accdb'],
    MS_EXCEL: ['xlsx'],
    MS_PUBLISHER: ['pub'],
    MS_WORD: ['docx', 'doc'],
  }

  let specificType = 'GENERIC'

  for (const [key, value] of Object.entries(map)) {
    if (value.map((v) => v.toLowerCase()).includes(extension.toLowerCase())) {
      specificType = key
      break
    }
  }

  return specificType as FileType
}
